package com.karawek.core.ui.components

import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.theme.CoreTheme

@Composable
fun CoreLoadingIndicator(
    modifier: Modifier = Modifier,
) {
    CircularProgressIndicator(
        modifier = modifier,
        color = CoreTheme.colors.primary,
    )
}
